module.exports = __webpack_public_path__ + "static/media/Awards.4936328a.svg";